import React from 'react';
import { Button, Card, CardContent, Typography, Box, Container, Grid } from '@mui/material';
import { Add as PlusCircle, Upload } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PermissionChecker from '../../../components/common/PermissionChecker';

export default function Dashboard() {
    const navigate = useNavigate();

    const handleDownloadTemplate = () => {
        // Create a CSV template content
        const csvContent = 'Position Title,Department,Location,Experience Required,Skills Required\n';
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'position_template.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    return (
        <Box sx={{ p: 4, bgcolor: 'background.default' }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography variant="h3" component="h1" sx={{ mb: 2, fontWeight: 600, color: 'primary.main' }}>
                        Welcome To Demand Management!
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
                        As A Program Manager, You Can Create New Position Demands Either Individually Or Through Bulk
                        Upload.
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {"Let's Get Started By Creating Your First Demand."}
                    </Typography>
                </Box>

                <Grid container spacing={3} maxWidth="lg" sx={{ mx: 'auto' }}>
                    {/* Create Individual Positions */}
                    <PermissionChecker
                        requiredPermissions={['ROLE_BASE_PERMISSION_PRE_HQ_CREATE_POSITIONS']}
                        noAuthRedirect={false}
                    >
                        <Grid item xs={12} md={6}>
                            <Card
                                sx={{
                                    p: 4,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                <CardContent
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 48,
                                            height: 48,
                                            bgcolor: 'orange.100',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 2,
                                        }}
                                    >
                                        <PlusCircle sx={{ color: 'orange.main', fontSize: 24 }} />
                                    </Box>
                                    <Typography
                                        variant="h5"
                                        component="h2"
                                        sx={{ mb: 1, fontWeight: 600, color: 'primary.main' }}
                                    >
                                        Create Individual Positions
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                                        Enter position details manually using our simple form.
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
                                        Best for creating single or a few positions.
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        startIcon={<PlusCircle />}
                                        onClick={() => navigate('/client/positions/create-position')}
                                        sx={{
                                            bgcolor: 'primary.main',
                                            '&:hover': { bgcolor: 'primary.dark' },
                                        }}
                                    >
                                        Create position
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    </PermissionChecker>
                    {/* Bulk Upload Positions */}
                    <PermissionChecker
                        requiredPermissions={['ROLE_BASE_PERMISSION_PRE_HQ_BULK_UPLOAD_POSITIONS']}
                        noAuthRedirect={false}
                    >
                        <Grid item xs={12} md={6}>
                            <Card
                                sx={{
                                    p: 4,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                <CardContent
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 48,
                                            height: 48,
                                            bgcolor: 'orange.100',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 2,
                                        }}
                                    >
                                        <Upload sx={{ color: 'orange.main', fontSize: 24 }} />
                                    </Box>
                                    <Typography
                                        variant="h5"
                                        component="h2"
                                        sx={{ mb: 1, fontWeight: 600, color: 'primary.main' }}
                                    >
                                        Bulk Upload Positions
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                                        Upload multiple positions at once using our Excel template.
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
                                        Perfect for creating many positions.
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        startIcon={<Upload />}
                                        onClick={() => navigate('/client/positions/bulk-upload')}
                                        sx={{
                                            borderColor: 'orange.main',
                                            color: 'orange.main',
                                            '&:hover': {
                                                borderColor: 'orange.dark',
                                                bgcolor: 'orange.50',
                                            },
                                        }}
                                    >
                                        Bulk upload
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    </PermissionChecker>
                </Grid>
            </Container>
        </Box>
    );
}
